<template>
  <div class="roleOptions mask" id="roleOptions">
    <el-form :model="menuForm" :rules="rules" ref="optsForm" label-width="100px" >
      <p v-if="!isAdd" class="title">编辑角色</p>
      <p v-else class="title">新增角色</p>
      <div class="scrollDiv">
        <el-form-item label="父级角色：" prop="pid"  class="inputRole">
          <el-select v-model="menuForm.pid" filterable clearable placeholder="角色名称"  @focus="getFatherMenu">
            <el-option :value="item.id" v-html="item.pre_name" v-for="item in fatherMenu" :key="item.id" :label="item.name" > 
            </el-option> 
          </el-select>
        </el-form-item>
        <el-form-item label="角色名称：" prop="name" class="inputRole" >
        <el-input placeholder="请输入内容" v-model="menuForm.name"></el-input>
        </el-form-item>
        <el-form-item label="描述：" prop="remark"  class="inputRole" >
          <el-input placeholder="请输入内容" v-model="menuForm.remark"></el-input>
        </el-form-item>
        <p class="power">权限</p>
        <el-tree :data="menuList" :props="props" show-checkbox default-expand-all v-if="menuList"
        :default-checked-keys="selectMenuList" node-key="id" :render-content="renderContent" 
        ref="tree"></el-tree>
      </div>
    
      <el-form-item class="btnForm">
        <span class="button btn-add" @click="submitForm()"> 确定</span>
        <span class="button" @click="cancle()">取消</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import { treeAuth } from '@/api/menu'
import { editGet,editPost,authTree,add } from '@/api/bonochRole'


export default {
  data(){
    return {
      isAdd: false,
      menuForm: {
        pid:"",
        name:"",
        rules:"",
        rules_btn:"",
        remark:""
      },
      props: {
        label: 'name',
        children: 'childlist'
      },
      rules:{
        name:[
          {required: true, message: '请输入角色名称', trigger: 'change'},
          {max: 10, message: '角色名称最多10个字符', trigger: 'blur' }
        ],
        pid:[
          {required: true, message: '请输入父级角色', trigger: 'change'}
        ],
        remark:[
          {max: 50, message: '描述最多50个字符', trigger: 'blur' }
        ]
      },
      menuList: [],//菜单列表
      id:"",
      selectMenuList:[],
      fatherMenu:[]
    }
  },
  props:['showRoleOpts'],
  created(){
    this.getMenuList()
  },
  mounted(){
    this.getFatherMenu()
  },
  watch:{
    showRoleOpts:function(n,o){
      if(this.showRoleOpts){
        if(this.id){
          this.getCurRole()
        }else{
          this.$refs.optsForm.clearValidate();
        }
      }
    },
  },
  methods:{
    submitForm(){
      this.$refs['optsForm'].validate((valid) => {
        if (valid) {
          let keys1 = this.$refs.tree.getHalfCheckedKeys()
          let keys2 = this.$refs.tree.getCheckedKeys()
          let halfCheck = keys1.concat(keys2)        
          let curCheck = this.$refs.tree.getCheckedKeys(true)
          this.menuForm.rules= halfCheck.join(',')
          this.menuForm.rules_btn = curCheck.join(',')
          if(this.isAdd){
            this.addRoles()
          }else{
            this.editRoles()
          }
        }else{
          const isError= document.getElementsByClassName('is-error')
          isError[0].querySelector('input').focus()
          return false;
        }
      })
      
    },
    editRoles(){
      this.menuForm.id = this.id
      editPost(this.menuForm).then(res=>{
        if(res==1){
          this.$emit('searchList')
          this.getMenuList()
          this.cancle()
          this.$message({message:'编辑角色成功',type:'success'})
        }
      })
    },
    addRoles(){
      add(this.menuForm).then(res=>{
        if(res.length==0){
          this.$emit('searchList')
          this.getMenuList()
          this.cancle()
          this.$message({message:'添加角色成功',type:'success'})

        }
      })
    },
    getFatherMenu(){
      authTree().then(res=>{
        this.fatherMenu = res
      })
    },
    getCurRole(){
      let params = {
        id:this.id
      }
      editGet(params).then(res=>{
        let list = res
        if(list.rules == '*'){
          this.selectMenuList = []
        }else {
          let array = list.rules_btn.split(',')
          this.selectMenuList = array
        }
        this.menuForm.pid= list.pid
        this.menuForm.name= list.name
        this.menuForm.remark= list.remark
      })
    },
    getMenuList(){
      treeAuth({
        system:"bonoch"
      }).then(res=>{
        this.menuList = res
        this.initTreeCSS()
      })
    },
    renderContent(h, { data }) {
      console.log(h)
      if (data.pid == 0 ){
        if(data.childlist && data.childlist.length>0){
          return(<div class="firstLevel"><span>{data.name}</span><span class="more">收起<i class="iconfont icon_more_active1"></i></span><span class="moreShow">展开<i class="iconfont icon_more_normal1"></i></span></div>)
        }else{
          return(<div class="firstLevel"><span>{data.name}</span><span></span></div>)
        }
      }
      if (data.is_menu==1){
        return(<div class="hasChild">{data.name}</div>)
      }else {
        return(<div class="noChild">{data.name}</div>)
      }
    },
    initTreeCSS(){
      this.$nextTick(()=>{
        let levelName  = document.getElementsByClassName('noChild');
        for (let i = 0; i < levelName.length; i++) {
          // cssFloat 兼容 ie6-8  styleFloat 兼容ie9及标准浏览器
          levelName[i].parentNode.style.cssFloat = 'left' // 最底层的节点，包括多选框和名字都让他左浮动
          levelName[i].parentNode.style.styleFloat = 'left'
          levelName[i].parentNode.style.width = '20%'
          levelName[i].parentNode.style.display = 'flex'
          levelName[i].parentNode.style.alignItems = 'center'
          levelName[i].parentNode.style.justifyContent = 'flex-start'
          levelName[i].parentNode.parentNode.parentNode.style.borderBottom = ' 1px solid #E9EDF0'
          levelName[i].parentNode.parentNode.parentNode.style.borderLeft = ' 1px solid #E9EDF0'
          levelName[i].parentNode.parentNode.parentNode.style.borderRight = ' 1px solid #E9EDF0'

        }
        let firstLevel  = document.getElementsByClassName('firstLevel');
        
        for (let i = 0; i < firstLevel.length; i++) {
          // cssFloat 兼容 ie6-8  styleFloat 兼容ie9及标准浏览器
          firstLevel[i].parentNode.style.color  = '#303030'
          firstLevel[i].parentNode.style.backgroundColor  = '#F7F8FC' // 最底层的节点，包括多选框和名字都让他左浮动
        }
        let hasChild  = document.getElementsByClassName('hasChild');
        for (let i = 0; i < hasChild.length; i++) {
          // cssFloat 兼容 ie6-8  styleFloat 兼容ie9及标准浏览器
          hasChild[i].parentNode.style.width  = '100%' // 最底层的节点，包括多选框和名字都让他左浮动
          hasChild[i].parentNode.style.border = ' 1px solid #E9EDF0'
          hasChild[i].parentNode.style.borderBottom = 'none'
          hasChild[i].parentNode.style.borderTop = 'none'
        }
      })
  
    },
     cancle(){
      this.menuForm = {
        pid:"",
        name:"",
        rules:"",
        rules_btn:"",
        remark:""
      }
      this.$refs.optsForm.clearValidate();
      this.$refs.tree.setCheckedNodes([])
      this.$emit('cancle',false)
    }
  }

}
</script>

<style lang='scss' >
@import '@/assets/scss/maskForm.scss';
#roleOptions {
  .scrollDiv{
    overflow-y: auto;
    height: 45vh;
    min-height: 300px;
    margin-left: 4.2vw;
    padding-right: calc(4.2vw - 24px);
    margin-right: 16px;
  }
  >.el-form{
    width: 72%;
    padding-bottom: 2.5%;
    >.title{
      padding: 2.9% 2.9% 0 2.9%;
    }
    .power{
      font-size: 14px;
      font-family:  Noto Sans SC;
      font-weight: 700;
      margin-bottom: 24px;
    }
    .btnForm{
      margin-bottom: 0;
      margin-right: 6%;
    }
    .inputRole{
      .el-input__inner{
        width: 360px;
      }
    }
  }
}

</style>
<style lang='scss'>
  .el-tree{
    &::-webkit-scrollbar {
      width: 8px;
      height: 10px;
    }
    //滚动条的滑块
    &::-webkit-scrollbar-thumb {
      background-color: #CCCCCC;
      border-radius: 6px;
    }
    .el-tree-node__content{
      height: 42px;
      line-height: 42px;
      font-size: 14px;
 
      &:hover{
        background-color: #F7F8FC;
      }

    }
    .el-tree-node.is-checked{
      background-color: #ffffff;
      color: #030303;
    }
  }
  .firstLevel{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #F7F8FC;
    font-size: 14px;
  
    >span:nth-of-type(1){
      font-family:  Noto Sans SC;
      font-weight: 700;
    }
    >span.more,
    >span.moreShow{
      font-size: 12px;
      padding-right: 22px;
    }
    .iconfont{
      font-size: 12px;
      margin-left: 4px;
    }
  }
  .el-tree-node.is-expanded{
    .more{display: block;}
    .moreShow{display: none;}
  }
  .el-tree-node
  {
    .more{display: none;}
    .moreShow{display: block;}
  }
  .noChild{
    margin-right: 26px;
  }
</style>